import React from 'react'

const PackingRejectionReport = () => {
  return (
    <div>PackingRejectionReport</div>
  )
}

export default PackingRejectionReport